import { render } from "./GameVictories.vue?vue&type=template&id=daf8b39e&scoped=true"
import script from "./GameVictories.js?vue&type=script&lang=js"
export * from "./GameVictories.js?vue&type=script&lang=js"

import "./GameVictories.scss?vue&type=style&index=0&id=daf8b39e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf8b39e"]])

export default __exports__